import type { BankAccountStatusUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getBankAccountStatusColor } from './helpers';

type BankAccountStatusBadgePropsType = {
  status: BankAccountStatusUnionType;
};

export const BankAccountStatusBadge: React.FC<
  BankAccountStatusBadgePropsType
> = ({ status }) => {
  const { t } = useTranslation();
  const { backgroundColor, textColor } = getBankAccountStatusColor(status);

  return (
    <Badge color={backgroundColor} style={{ color: textColor }}>
      {t(`BANK_ACCOUNTS.STATUS.${status}`)}
    </Badge>
  );
};
